import config from 'config'
import { useState } from 'react'
import { fetchAction } from 'utils'

const useStoreSearch = (requestParams = {}, initialValue = '') => {
  const [input, setInput] = useState(initialValue)
  const [results, setResults] = useState([])
  const [isLoading, setLoading] = useState(false)

  const getResults = async filter => {
    if (filter !== '') {
      setLoading(true)
      const { data } = await fetchAction(config.api.stores, {
        ...requestParams,
        filter,
      })
      setResults(data)
      setLoading(false)
    }
  }

  const onChange = val => {
    setInput(val)
  }

  return {
    value: input,
    onChange,
    results,
    triggerSearch: getResults,
    loading: isLoading,
  }
}

export default useStoreSearch
